{
  "404": {
    "text": {
      "1": "Ця сторінка не існує.",
      "2": "Tap/click on a screen to continue",
      "3": "Перенаправлення..."
    }
  },
  "about-me": {
    "title": "Про мене",
    "list": [
      { "title": "{{totalExperience}} досвіду у комерційній розробці програмного забезпечення." },
      { "title": "Досвід в управлінні командою." },
      { "title": "Ведення проектів та розробкою функціональності." },
      { "title": "Проектування архітектури програмного забезпечення." },
      { "title": "Планування функціональності та їх своєчасна доставка." },
      { "title": "Проведення технічних та менеджерських співбесід." },
      { "title": "Досвід роботи з кількома командами та відділами для інтеграції всіх частин розробки разом." },
      { "title": "Досвід навчання та наставництва молодших колег." },
      { "title": "Впевнені знання та досвід у розробці backend, frontend, інфраструктури та CI/CD." },
      { "title": "Великий досвід Java, TypeScript, Go, Python, GitHub Actions, DevSecOps, Application Security." },
      { "title": "Написання клієнтської та внутрішньої документації." },
      { "title": "Публікація технічних статей." },
      {
        "title": "Участь в open source спільноті:",
        "list": [
          { "title": "Створення pull requests та відкриття тикетів у open source проектах." },
          { "title": "Розроблено та випущено в marketplace більш ніж 35 GitHub Actions." },
          { "title": "Активна участь у StackOverflow та LeetCode дискусіях." }
        ]
      }
    ]
  },
  "author": {
    "full-name": "Євген Фабіжевський",
    "given-name": "Євген",
    "job-title": "Розробник програмного забезпечення"
  },
  "badges": {
    "title": "Бейджі"
  },
  "by-issuer": "від {{issuer}}",
  "certificates": {
    "title": "Сертифікати",
    "list": {
      "MWE43H8YDS": "Програмування для всіх (Python)",
      "W5AB2PBZQNPY": "Паралельне, конкурентне та розподілене програмування в Java спеціалізації",
      "UC-JGDVYKAQ": "Повний курс React розробника (з хуками та Redux)",
      "689b9d7e-cae5-4e36-8a1f-c8c34f104249": "Oracle Certified Associate, Програміст Java SE 8",
      "F75CDD8ED9F0": "Розв'язування задач (Базовий рівень)",
      "24722d5e-1738-4cec-808b-b4b83a94a8ad": "GitHub Advanced Security",
      "711c8e30-13e7-499e-aad6-5da9d468177a": "GitHub Actions",
      "6f36f952-612a-4aa1-8a3d-adb29396c967": "GitHub Foundations",
      "a1c1ec77-29db-4139-8fcb-ac95408653e8": "GitHub Administration",
      "9f12275d-a5b5-4d4d-9127-c975c555f0ab": "Certified DevSecOps Professional (CDP)",
      "55ddd8bd-950d-45bb-ad25-d08269bc9ca1": "GitHub Copilot",
      "517b6607-def7-46e1-b007-493a15b5eeb2": "Terraform Associate (003)"
    }
  },
  "comma": ", ",
  "contacts": {
    "title": "Контакти",
    "location": "Токіо, Японія"
  },
  "education": {
    "title": "Освіта",
    "university": {
      "osar": {
        "speciality": "Інформаційні технології. Магістр.",
        "title": "Одеська Державна Академія Холоду"
      }
    }
  },
  "experience": {
    "present": "Зараз",
    "title": "Досвід",
    "tech-stack": "Технології",
    "achievements": "Досягнення",
    "body": {
      "woven-by-toyota": [
        "Розробив 3 основних Application Security GitHub Actions для виконання сканування коду, SCA і SBOM-аналізу. Вони широко використовуються у всій компанії. Наразі на день відбувається понад 1000 викликів цих GitHub Actions.",
        "Розробив систему авторизації/аутентифікації, яку використовують як основну систему в межах усього департаменту (11 команд).",
        "Зібрав команду з 6 інженерів. В обов'язки входив розгляд кандидатів, процес найму, наставництво і допомога в особистісному зростанні.",
        "Як чемпіон з безпеки в команді я налаштував найкращі практики безпеки застосунків на більш ніж 50 репозиторіях (frontend, backend, IaC тощо).",
        "Налаштував Keycloak як систему авторизації/аутентифікації для бекенда.",
        "Ведення бекенд-проєкту мовою Go на всіх рівнях і етапах розробки."
      ],
      "bitcoin-com": [
        "Збільшення покриття коду юніт-тестів у проєкті бекенда на Java з 0% до 80%.",
        "Відновив застарілий додаток для Android. Оновив його до останньої версії, зробив редизайн, додав додаткові функції та опублікував новий реліз.",
        "Налаштував Travis CI для бекенд-додатку з нуля.",
        "Налаштував Bitrise для застарілих Android-додатків з нуля.",
        "Налаштував GitHub Actions для веб-додатку з нуля."
      ],
      "lohika": "Lohika - це аутсорсингова компанія, в якій я працював як офшорний підрядник для різних компаній, але переважно для Hewlett Packard Enterprise. Я розробляв RIA, backend, мобільні та різні веб-додатки.",
      "arka": "Брав участь у розробці внутрішнього проєкту, пов'язаного з інвестиціями. Також розробляв різні веб-додатки для зовнішніх клієнтів, переважно з Німеччини."
    }
  },
  "header": {
    "occupation": "Розробник програмного забезпечення",
    "title": "Привіт, я {{authorGivenName}}"
  },
  "languages": {
    "title": "Мови",
    "fluent": "Вільне володіння",
    "native": "Рідна",
    "codes": {
      "gb": "Англійська",
      "jp": "Японська",
      "ru": "Російська",
      "ua": "Українська"
    }
  },
  "locations": {
    "odesa": "Одеса, Україна",
    "chuo": "Чуо, Токіо, Японія",
    "shibuya": "Шибуя, Токіо, Японія"
  },
  "month": ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
  "resume": {
    "title": "Резюме",
    "body": "Для того, щоб завантажити моє резюме, будь ласка, відкрийте мою <1>сторінку LinkedIn</1> і виберіть Resources → Save to PDF"
  },
  "skills": {
    "title": "Навички"
  },
  "stats": {
    "title": "Статистика"
  },
  "themes": {
    "light": "Світла",
    "dark": "Темна"
  },
  "title": "{{authorFullName}} :: {{authorJobTitle}}",
  "version": "Версія {{version}}",
  "year": "рік"
}
